// --- React
import React, { useCallback } from "react";
// --- UI Components
import Toast from "@dtci/spellbook/Toast";
import { ToastPopout, ToastContainer } from "@dtci/spellbook/ToastPopout";
import Typography from "@dtci/spellbook/Typography";
// --- Styles
import styles from "./ppt-toast-notifications.module.scss";

const TOAST_ID = "ppt-toast-notifications-container";

/**
 * Custom hook to display toast notifications.
 *
 * @returns {Object} Contains the `openToast` function to trigger toast notifications.
 */
export const usePPTToastNotification = () => {
  const openToast = useCallback((message, type = "info") => {
    let icon = "fa-circle-exclamation";

    if (type === "success") icon = "fa-check-circle";

    return ToastPopout({
      position: "top-right",
      closeOnClick: true,
      animate: true,
      containerId: TOAST_ID,
      content: (
        <Toast
          className={styles.container}
          type={type}
          iconTypePrimary={`fa-regular fa-beat fa-lg ${icon}`}
          theme="light"
        >
          <Typography variant="T30">{message}</Typography>
        </Toast>
      ),
    });
  }, []);

  return { openToast };
};

/**
 * ToastNotificationProvider component that initializes a toast notification container.
 *
 * @returns {JSX.Element} The rendered ToastContainer component.
 */
const PPTToastNotificationProvider = () => (
  <ToastContainer
    containerId={TOAST_ID}
    enableMultiContainer
    inline={false}
    autoClose={5000}
  />
);

export default PPTToastNotificationProvider;
